module.exports = __webpack_public_path__ + "static/media/image_13.04680494.png";